import { render } from "./LegacyEmailContentWrap.vue?vue&type=template&id=5067f0ad"
import script from "./LegacyEmailContentWrap.vue?vue&type=script&lang=js"
export * from "./LegacyEmailContentWrap.vue?vue&type=script&lang=js"
script.render = render

export default script